import { Skeleton } from "primereact/skeleton";
const MeaLoadingContent = ({ objectQuery, children }) => {
  return (
    <>
      {((objectQuery?.isLoading)) && (
        <Skeleton width="10rem" className="mb-2" />
      ) || children}
    </>
  );
};
export default MeaLoadingContent;
